/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../ui_elements/common';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "service": {
            "nested": {
              "v1": {
                "nested": {
                  "HeadlessCompletionScreen": {
                    "fields": {
                      "id": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "status": {
                        "type": ".squareup.bbfrontend.service.v1.HeadlessCompletionScreen.Status",
                        "id": 2,
                        "rule": "optional"
                      },
                      "toast": {
                        "type": ".squareup.bbfrontend.service.v1.Toast",
                        "id": 3,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Status": {
                        "values": {
                          "STATUS_DO_NOT_USE": 0,
                          "SUCCESS": 1,
                          "FAILED": 2
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.HeadlessCompletionScreen && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.HeadlessCompletionScreen?.nested?.Status) {
  $root.addJSON(jsonData);
}

/**
 * This screen is returned when we want to skip the UI and just emit an output.
 *
 * SOURCE HeadlessCompletionScreen @ squareup/bbfrontend/common/workflow/screens/headless_completion_screen.proto at 15:1
 */
export const HeadlessCompletionScreen = $root.lookupType('squareup.bbfrontend.service.v1.HeadlessCompletionScreen');
fixType(HeadlessCompletionScreen, {
  id: {
    required: true
  },
  status: {
    required: true
  }
});
Builder.createAndAttachToType(HeadlessCompletionScreen);
/**
 * SOURCE Status @ squareup/bbfrontend/common/workflow/screens/headless_completion_screen.proto at 23:3
 */
HeadlessCompletionScreen.Status = $root.lookupEnum('squareup.bbfrontend.service.v1.HeadlessCompletionScreen.Status').values;